export function ComplaintListTabs() {
  return [
    {
      text: "All",
      path: `/customer-complaints?tab=all`,
      applicationFeatureCode: "CustomerComplaints",
      id: "all",
    },
    {
      text: "Open",
      path: `/customer-complaints?tab=open`,
      applicationFeatureCode: "CustomerComplaints",
      id: "open",
    },
    {
      text: "Investigating",
      path: `/customer-complaints?tab=investigating`,
      applicationFeatureCode: "CustomerComplaints",
      id: "investigating",
    },
    {
      text: "Resolved",
      path: `/customer-complaints?tab=resolved`,
      applicationFeatureCode: "CustomerComplaints",
      id: "resolved",
    },
    {
      text: "Cancelled",
      path: `/customer-complaints?tab=cancelled`,
      applicationFeatureCode: "CustomerComplaints",
      id: "cancelled",
    }
  ];
}

export function GetIndexByTabName(tabName) {
  const tabs = ComplaintListTabs();
  const index = tabs.findIndex((tab) => tab.text.toLowerCase() === tabName.toLowerCase());
  return index !== -1 ? index : 0;
}

export const ComplaintTabFilters = {
  all: [],
  open: [["Status", "=", "Open"]],
  investigating: [["Status", "=", "Investigating"]],
  resolved: [["Status", "=", "Resolved"]],
  cancelled: [["Status", "=", "Cancelled"]],
};
